module.exports = __webpack_public_path__ + "img/carousel-clientes-18.63ace921.png";